/* istanbul ignore file */
import { isFeatureEnabled } from '@lumapps/features';
import { isSuperAdmin } from '@lumapps/permissions';

const isMobileAllowed = isSuperAdmin;
const isMobileNavigationEnabled = isFeatureEnabled('mobile-navigation');
const isMobileChatEnabled = isFeatureEnabled('mobile-chat');

export { isMobileAllowed, isMobileNavigationEnabled, isMobileChatEnabled };
